// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.cards-container {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: space-between;
  margin-top: 24px;
}

.card {
  background: #ffffff;
  border: 1px solid #d1d1d1;
  border-radius: 12px;
  width: calc(25% - 20px); /* 4 карточки в ряд, учитывая gap */
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease-in-out;
}
.card:hover {
  transform: translateY(-5px);
}

.card-icon {
  font-size: 40px; /* Замените иконки на SVG или другие */
  margin-right: 20px;
}

.card-info {
  display: flex;
  flex-direction: column;
}

.card-title {
  font-family: "Montserrat Regular", sans-serif;
  font-size: 16px;
  color: #757575;
}

.card-value {
  font-family: "Montserrat Bold", sans-serif;
  font-size: 24px;
  color: #000000;
  margin-top: 5px;
}`, "",{"version":3,"sources":["webpack://./src/routes/pages/StatisticsPage/StatisticCard/DashboardCard.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,8BAAA;EACA,gBAAA;AAEJ;;AACA;EACI,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA,EAAA,mCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,0CAAA;EACA,sCAAA;AAEJ;AAAI;EACI,2BAAA;AAER;;AAEA;EACI,eAAA,EAAA,sCAAA;EACA,kBAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;AACJ;;AAEA;EACI,6CAAA;EACA,eAAA;EACA,cAAA;AACJ;;AAEA;EACI,0CAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AACJ","sourcesContent":[".cards-container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 24px;\n    justify-content: space-between;\n    margin-top: 24px;\n}\n\n.card {\n    background: #ffffff;\n    border: 1px solid #d1d1d1;\n    border-radius: 12px;\n    width: calc(25% - 20px); /* 4 карточки в ряд, учитывая gap */\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n    transition: transform 0.2s ease-in-out;\n\n    &:hover {\n        transform: translateY(-5px);\n    }\n}\n\n.card-icon {\n    font-size: 40px; /* Замените иконки на SVG или другие */\n    margin-right: 20px;\n}\n\n.card-info {\n    display: flex;\n    flex-direction: column;\n}\n\n.card-title {\n    font-family: 'Montserrat Regular', sans-serif;\n    font-size: 16px;\n    color: #757575;\n}\n\n.card-value {\n    font-family: 'Montserrat Bold', sans-serif;\n    font-size: 24px;\n    color: #000000;\n    margin-top: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cards-container": `cards-container`,
	"card": `card`,
	"card-icon": `card-icon`,
	"card-info": `card-info`,
	"card-title": `card-title`,
	"card-value": `card-value`
};
export default ___CSS_LOADER_EXPORT___;
